import { Component, OnInit, OnDestroy } from '@angular/core'
import { environment } from 'src/environments/environment'
import { LoginService } from '../login/login.service'
import { BuilderService } from '../builder-services/builder.service'
import { SidebarService } from './sidebar.service'
import { AppUsersService } from '../app-users/services/app-users.service'
import { Observable, of, Subscription } from 'rxjs'
import { catchError, filter, map } from 'rxjs/operators'
import { NavigationEnd } from '@angular/router'
import { BlockDataService } from '../block-services/block-data.service'
import { AppSettingsService } from '../settings/services/app-settings.service'
import { MatDialog } from '@angular/material/dialog'
import { WorksDialogComponent } from '../pages/works-dialog/works-dialog.component'
import { Router, ActivatedRoute } from '@angular/router'
import { VendorService } from '../multivendor/vendor.service'
export interface MenuItem {
  name: string
  icon: string
  route: string
}

@Component({
  selector: 'sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  isActive = false
  menus: MenuItem[] = []
  projectId = this.builderService.selectedProject
  user_email = this.loginService.getCurrentUser().email
  analyticsLink: any;
  private queryParamsSubscription: Subscription | undefined;
  private navSubscription: Subscription | undefined;

  constructor(
    public loginService: LoginService,
    public builderService: BuilderService,
    private sidebarService: SidebarService,
    private AppUsersService: AppUsersService,
    private blockDataService: BlockDataService,
    private appSettingsService: AppSettingsService,
    private dialog: MatDialog,
    public vendor: VendorService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.sidebarService.getMenuItems().subscribe((data) => {
      this.menus = data
    })
    this.blockDataService.getProjectCached().subscribe((projectId) => {
      this.packageType = JSON.parse(this.builderService.cacheProjectReq.response.premium[0].package).type;
    })
  }

  mobile = false
  appDropdown = false
  commerceDropdown = false
  activeMenu: string | null = 'ecommerce'
  packageType: any
  // sidebarCollapsed = true;
  environment = environment
  ngOnInit(): void {
    if (window.innerWidth <= 768) {
      // 768px portrait
      this.mobile = true
    }

    // On mobile viewports, start with sidebar closed (bottom sheet hidden)
    if (window.innerWidth <= 768) {
      this.builderService.sidebarOpened = false
    }

    // Auto-close bottom sheet after any navigation on mobile
    this.navSubscription = this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe(() => {
      if (window.innerWidth <= 768) {
        this.builderService.sidebarOpened = false
      }
    })

    this.handleUserRole()

    // Subscribe to query params changes to handle genie mode updates
    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      console.log('Sidebar received query params:', params);
      if (params['genie'] === 'true' && params['genieMode']) {
        // Update localStorage with the new genieMode
        localStorage.setItem('genieMode', params['genieMode']);
        // Handle the genie mode navigation
        this.handleGenieMode();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
    if (this.navSubscription) {
      this.navSubscription.unsubscribe();
    }
  }

  toggleSideMenu() {
    this.builderService.sidebarOpened = !this.builderService.sidebarOpened
    this.commerceDropdown = false
    this.appDropdown = false
  }

  toggleListedCommerce() {
    this.builderService.sidebarOpened = true
    this.commerceDropdown = !this.commerceDropdown
  }
  toggleGenerate() {
    this.builderService.sidebarOpened = true
    this.appDropdown = !this.appDropdown
  }

  toggleMenu(menuId: string) {
    this.builderService.sidebarOpened = true
    this.activeMenu = this.activeMenu === menuId ? null : menuId
  }
  routeToAnalitcs(){
        //Gets the General settings to get the appname 
    // this.appSettingsService.getGeneralSettings(this.builderService.selectedProject).subscribe(
    //   (settings: any) => {     
    //     //gets the firebase settings to apply them to route to analytics
    //   this.appSettingsService.getFirebaseSettings(this.builderService.selectedProject).subscribe((fireSettings) => {
    //     //checks if the needed routes exist 
    //     if(fireSettings.stacks_user_projectId && fireSettings.stacks_user_messagingSenderId){
    //       //this is the link to the realtime analytics
    //       this.analyticsLink = "https://console.firebase.google.com/u/0/project/" + fireSettings.stacks_user_projectId + "/analytics/app/android:" + settings.package_name + '/streamview/realtime~2Foverview%3Ffpn%3D' + fireSettings.stacks_user_messagingSenderId;
    //       //opens in a new window
    //       window.open(this.analyticsLink, '_blank')
    //     }else{
    //       //shows the popup to add the missing firebase settings
    //       this.howItWorksDialog()
    //     }
    //   })
    // })

    // Route to PostHog analytics dashboard
    this.router.navigate(['/analytics/posthog'])
  }

  howItWorksDialog = () => {
      const dialogRef = this.dialog.open(WorksDialogComponent, {
        width: 'auto',
        maxWidth: '100%',
        data: { name: 'analytics' }
      })
  
      dialogRef.afterClosed().subscribe((result) => {
        //routes after closing to the settings page
        this.router.navigate([`/firebasesettings`])

      })
    }

  // sidebarHome = () => {
  //   this.sidebarCollapsed = !this.sidebarCollapsed;
  // }
  isAdmin(): boolean {
    if (this.loginService.getCurrentUser().admin) {
      return true
    }
    return false
  }

  checkUserRole(): Observable<string | null> {
    return this.AppUsersService.getUsersByProjectId(this.projectId).pipe(
      map((projectUsers: any) => {
        const currentUser = projectUsers.find((user: any) => this.user_email === user.email)
        let userRole = currentUser ? currentUser.user_role : null
        return userRole
      }),
      catchError((error) => {
        console.error('Error fetching users by project ID:', error)
        return of(null)
      })
    )
  }

  handleUserRole() {
    this.checkUserRole().subscribe((currentUserRole) => {
      if (currentUserRole == 'orderManager') {
        this.builderService.isOrderManager = true
      }
      if (currentUserRole == 'productManager') {
        this.builderService.isProductManager = true
      }
      if (currentUserRole == 'stockManager') {
        this.builderService.isStockManager = true
        this.router.navigate(['/products'])
      }
    })
  }

  closeMobileSidebar() {
    this.builderService.sidebarOpened = false
  }

  /**
   * Handles automatic navigation based on genie mode
   */
  handleGenieMode() {
    if (this.builderService.isFromGenie()) {
      const genieMode = this.builderService.getGenieMode()

      // Get current query params to preserve them
      const currentParams = {
        projectId: localStorage.getItem('selectedProject'),
        token: localStorage.getItem('token'),
        genie: 'true',
        genieMode: genieMode
      };

      if (genieMode === 'design') {
        // Navigate to Mobile Builder (first element in design mode)
        this.router.navigate(['/'], { queryParams: currentParams })
      } else if (genieMode === 'data') {
        // stacks-chat sends geniePage=payments once the website is built and the merchant agreed to
        // connect a payment gateway. Kept in the params so the query-param re-emit after this
        // navigation doesn't bounce back to Products.
        const geniePage = this.route.snapshot.queryParams['geniePage']
        if (geniePage === 'payments') {
          this.router.navigate(['/e-commerce/payments'], { queryParams: { ...currentParams, geniePage } })
        } else {
          // Navigate to Products (first element in data mode E-Commerce submenu)
          this.router.navigate(['/products'], { queryParams: currentParams })
        }
        this.activeMenu = 'ecommerce'
      } else if (genieMode === 'settings') {
        // Navigate to App Basics (first element in settings mode)
        this.router.navigate(['/app-basics'], { queryParams: currentParams })
      }
    }
  }
}
